import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { fetchDealerConfig } from '@/features/dealers/store/dealerConfigSlice';
import { resolveCanSelfCollectPayment } from '@/features/dealers/utils/resolveCanSelfCollectPayment';

/** Resolves `false` until the dealer config lands, so the who-collects gate fails closed to
 *  Elemis while a read is in flight. */
export function useCanSelfCollectPayment(dealerId: string | null): boolean {
    const dispatch = useAppDispatch();
    const settings = useAppSelector((s) => (dealerId ? s.dealerConfig.byDealerId[dealerId] : undefined));
    const status = useAppSelector((s) => (dealerId ? s.dealerConfig.status[dealerId] : undefined)) ?? 'idle';

    useEffect(() => {
        if (dealerId && status === 'idle') {
            void dispatch(fetchDealerConfig(dealerId));
        }
    }, [dispatch, dealerId, status]);

    return resolveCanSelfCollectPayment(settings);
}
